<template>
  <transition name="fade">
    <div
      v-if="value"
      class="popup-full"
    >
      <div
        v-click-out="() => $emit('input', false)"
        class="popup-full__wrap"
      >
        <button
          type="button"
          class="popup-full__close"
          @click="$emit('input', false)"
        >
          <BaseSvg name="ico-close" />
        </button>

        <div class="popup-full__scroll">
          <div class="popup-full__content">
            <div class="popup-full__media">
              <picture class="popup-full__img">
                <img
                  src="../../assets/img/resume-popups/question.svg"
                  alt="А что дальше?"
                >
              </picture>
            </div>

            <h3 class="popup-full__title">{{ $tMyVacancy(`What's next?'`) }}</h3>
            <div class="popup-full__text text">
              <p>{{ $tMyVacancy(`What's next text`) }}</p>
            </div>

            <ul class="popup-full__list">
              <li class="popup-full__list-item">
                <span class="popup-full__list-number">1</span>
                <span>
                  {{ $tMyVacancy(`what_next_step_1`) }}
                </span>
              </li>

              <li class="popup-full__list-item">
                <span class="popup-full__list-number">2</span>
                <span>
                  {{ $tMyVacancy(`what_next_step_2`) }}
                </span>
              </li>

              <li class="popup-full__list-item">
                <span class="popup-full__list-number">3</span>
                <span>
                  {{ $tMyVacancy(`what_next_step_3`) }}
                </span>
              </li>
            </ul>

            <div class="popup-full__buttons">
              <button
                type="button"
                class="popup-full__btn  base-btn base-btn--green"
                @click="$emit('input', false)"
              >
                <span>ОК</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import { blockScroll, unBlockScroll } from '@/helpers/scroll';

  export default {
    name: 'AccountMyVacanciesWhatNextModal',

    props: {
      value: {
        type: Boolean
      }
    },

    watch: {
      value() {
        if (this.value) blockScroll();
        else unBlockScroll();
      }
    }
  };
</script>
